export const safelyShiftScale = (number: number | string, scale: number): number => {
    const [value, exponent] = `${number}e`.split("e");
    return +`${value}e${+exponent + scale}`;
};
